var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.viewRequiresAuth())?_c('v-app',{staticClass:"scrollbar-hidden"},[_c('router-view')],1):_c('v-app',{staticClass:"scrollbar-hidden"},[_c('Sidebar'),_c('v-app-bar',{staticClass:"elevation-0",attrs:{"dense":"","app":""}},[_c('Header')],1),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }